<template>
  <div name="demo-table-inline-edit">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :editInlineEventBool="true"
                :saveInlineEvent="showFlgDetails"
                :columnEvent="columnEvent" />

    <template v-if="objs.edit.rows.length > 0">
      <h3>{{desc.edit}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.edit"
                  :maxRowspan="maxRowspan" />
    </template>
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.inlineLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'edit', flgRowCondition)
let mockMaxRowspan = 2
let mockData = mock.dataInline(flgRowCondition)

export default {
  name: 'demo-table-inline-edit',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData,
      maxRowspan: mockMaxRowspan,
      objs: {
        edit: {
          total: 0,
          rows: []
        }
      },
      desc: {
        edit: ''
      }
    }
  },
  methods: {
    showFlgDetails (params) {
      var inlineObjs = [{
        flg: 'edit',
        desc: 'edited'
      }]
      for (var inlineObj of inlineObjs) {
        var dataRows = params.filter(function (paramRow) {
          return paramRow.flg === inlineObj.flg
        })
        this.objs[inlineObj.flg].total = dataRows.length
        this.objs[inlineObj.flg].rows = dataRows
        var total = dataRows.length
        if (total <= 1) {
          this.desc[inlineObj.flg] = 'Data is ' + inlineObj.desc + ' ' + total + ' row'
        } else {
          this.desc[inlineObj.flg] = 'Data are ' + inlineObj.desc + ' ' + total + ' rows'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableInlineEdit.vue?1f405202